import { useFormContext } from 'react-hook-form';
import styles from '@components/loginModal/find/find.module.scss';
import LabelInput from '@components/labelInput';
import { nameValidator } from '@utils/validators/validators';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

export const Name = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={cx('infoWrap')}>
      <LabelInput
        {...register('name', { validate: (value: string) => nameValidator(value) })}
        type="text"
        className={cx('input', { error: errors.name })}
        placeholder="이름"
        maxLength={17}
        autoComplete="off"
      />
    </div>
  );
};
